import gql from 'graphql-tag';

export const ParselyArticleCards = gql`
  query ParselyArticleCards($slugs: [String], $limit: Int) {
    articleCollection(
      where: { slug_in: $slugs, discoverable: true }
      limit: $limit
      preview: false
    ) {
      total
      items {
        sys {
          id
        }
        title
        readTimeComputed
        shortDescription
        editorialLastPublishedDateComputed
        editorialOriginalPublishDate
        slug
        primaryImage {
          describedImage
          maxWidth
          image {
            title
            url
          }
        }
        # An article could have 2 categories. One parent and one child
        categoriesCollection(limit: 2) {
          items {
            title
            parentCategory {
              title
            }
            linkedFrom {
              categoryAssemblyCollection(limit: 1) {
                items {
                  slug
                  category {
                    title
                  }
                }
              }
            }
          }
        }
        authorsCollection(limit: 1) {
          items {
            displayName
            email
            primaryImage {
              describedImage
              maxWidth
              image {
                title
                url
                width
                height
              }
            }
            biographyShort
          }
        }
      }
    }
  }
`;

export const ParselyMiniArticleCards = gql`
  query ParselyMiniArticles($slugs: [String], $limit: Int) {
    articleCollection(
      where: { slug_in: $slugs, discoverable: true }
      limit: $limit
      preview: false
    ) {
      total
      items {
        sys {
          id
        }
        title
        slug
        categoriesCollection(limit: 2) {
          items {
            title
            parentCategory {
              title
            }
            linkedFrom {
              categoryAssemblyCollection(limit: 1) {
                items {
                  slug
                  category {
                    title
                  }
                }
              }
            }
          }
        }
        primaryImage {
          describedImage
          maxWidth
          image {
            title
            url
          }
        }
      }
    }
  }
`;

export const ParselyUpNext = gql`
  query ParselyUpNextArticle($slugs: [String]) {
    articleCollection(
      where: { slug_in: $slugs, discoverable: true }
      limit: 1
      preview: false
    ) {
      total
      items {
        sys {
          id
        }
        title
        shortDescription
        slug
        categoriesCollection(limit: 2) {
          items {
            title
            parentCategory {
              title
            }
            linkedFrom {
              categoryAssemblyCollection(limit: 1) {
                items {
                  slug
                  category {
                    title
                  }
                }
              }
            }
          }
        }
        primaryImage {
          describedImage
          maxWidth
          image {
            title
            url
          }
        }
      }
    }
  }
`;
